<div class="modal-header">
  <button
    type="button"
    class="close"
    aria-label="Close button"
    aria-describedby="modal-title"
    (click)="cerrar()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <h1 class="modal-title cl-titl" id="modal-title">Para continuar por favor completar los siguientes documentos anexos.</h1>
  <div style="margin-bottom: 50px">
    <!-- <ul>
      <li (click)="openOneModal(modalDjResidencia)" class="cl-li mb-4">
        -ANEXO DJ RESIDENCIA FISCAL PJ
        <img *ngIf="!check1" src="assets/images/loading.gif" width="20px" />
        <img *ngIf="check1" src="assets/images/check.png" width="20px" />
      </li>
      <li (click)="openOneModal(modalDjPep)" class="cl-li mb-4">
        -ANEXO DJ PEP
        <img *ngIf="!check2" src="assets/images/loading.gif" width="20px" />
        <img *ngIf="check2" src="assets/images/check.png" width="20px" />
      </li>
      <li (click)="openOneModal(modalDjInversionista)" class="cl-li mb-4">
        -ANEXO DJ INVERSIONISTA INSTITUCIONAL
        <img *ngIf="!check3" src="assets/images/loading.gif" width="20px" />
        <img *ngIf="check3" src="assets/images/check.png" width="20px" />
      </li>
    </ul> -->
    <ul>


      <li 
        *ngIf="estAct1"
        (click)="openOneModal(modalDjResidencia)"
        class="cl-li mb-4"
      >
        -Anexo DJ residencia fiscal PJ
        <img src="assets/images/loading.gif" width="20px" />
      </li>

      <li *ngIf="!estAct1" class="cl-li-nopointer mb-4">
        -Anexo DJ residencia fiscal PJ
        <img src="assets/images/check.png" width="20px" />
      </li>

      <li *ngIf="estAct4" (click)="openOneModal(modalDjPep)" class="cl-li mb-4">
        -Anexo DJ PEP
        <img src="assets/images/loading.gif" width="20px" />
      </li>

      <li *ngIf="estAct5" class="cl-li-nopointer mb-4">
        -Anexo DJ PEP
        <img src="assets/images/loading.gif" width="20px" />
      </li>

      <li *ngIf="estAct2" class="cl-li-nopointer mb-4">
        -Anexo DJ PEP
        <img src="assets/images/check.png" width="20px" />
      </li>

      <li
        *ngIf="estAct3"
        (click)="openOneModal(modalDjInversionista)"
        class="cl-li mb-4"
      >
        -Anexo DJ inversionista institucional
        <img src="assets/images/loading.gif" width="20px" />
      </li>

      <li *ngIf="estAct8" class="cl-li-nopointer mb-4">
        -Anexo DJ inversionista institucional
        <img src="assets/images/loading.gif" width="20px" />
      </li>

      <li *ngIf="estAct7" class="cl-li-nopointer mb-4">
        -Anexo DJ inversionista institucional
        <img src="assets/images/check.png" width="20px" />
      </li>
    </ul>
  </div>
  <div class="col-md-12 empuje" align="center">
    <div class="form-group">
      <button
        disabled
        *ngIf="prosigue"
        style="width: 50%"
        class="btn btn-rounded btn-blue btn-block"
      >
        Registrar
      </button>

      <button
        *ngIf="!prosigue"
        style="width: 50%"
        class="btn btn-rounded btn-blue btn-block"
        (click) = "registrarAnexo()"
   
      >
        Registrar
      </button>
    </div>
  </div>
</div>

<ng-template #modalDjResidencia let-modal>
  <div class="modal-header">
    <button
      type="button"
      class="close"
      aria-label="Close button"
      aria-describedby="modal-title"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h4 class="modal-title cl-titl" id="modal-title">
      Anexo DJ residencia fiscal PN
    </h4>
    <form [formGroup]="form3">
      <div>
        <p class="cl-txt">
          Acepta las siguientes condiciones:<br />
          1. Haber sido informado por LA COMPAÑÍA sobre la ley denominada
          Foreign Account Tax Compliance Act - FATCA (Ley de scalización de
          cuentas extranjeras), aprobada por el Congreso de los EE.UU., cuya
          nalidad es la de mejorar los mecanismos de scalización de las
          inversiones que mantienen fuera de los EE.UU. las personas clasicadas
          por la ley como "US Persons".
          <br />
          2. Ser una US Person para efectos de FATCA y los autorizo desde ya, de
          manera libre, expresa, informada e inequívoca, a brindar a la
          autoridad tributaria competente (ya sea la SUNAT o el Internal Revenue
          Service -IRS- del gobierno de los Estados Unidos de Norteamérica) la
          información sobre mis Datos Personales (nombre, documento ocial de
          identidad, dirección, nacionalidad, documento de identicación scal,
          tipo y número o código de la(s) cuenta(s) que mantengo en la entidad
          nanciera), detalle de movimientos y saldos de mis cuentas y productos,
          así como cualquier otra información que pueda ser requerida con el
          propósito de cumplir con la mencionada Ley.
        </p>
        <p class="cl-check">Autocertificación CRS - PJ</p>
        <div class="row mb-4">
          <div class="col-lg-6">
            <p class="cl-check">
              ¿Tiene obligaciones fiscales en otro(s) país(es) (incluye país de
              constitución)?
            </p>
            <select
              formControlName="quest1"
         
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="optionC($event)"
              class="form-control"
            >
              <option disabled value="">Selecciona una opción</option>
              <option value="Si">Si</option>
              <option value="No">No</option>
            </select>
          </div>
          <div class="col-lg-3" *ngIf="boxing">
            <label for="tipo_documento" class="color-s">Paises </label>
            <select formControlName="quest2" class="form-control">
              <option disabled value="null">Selecciona una opción</option>
              <option value="Peru">Peru</option>
            </select>
          </div>
          <div class="col-lg-3" *ngIf="boxing">
            <label for="tipo_documento" class="color-s">NIT </label>
            <input
              formControlName="quest3"
              (keypress)="numberOnly($event)"
              maxlength="15"
              class="form-control"
              type="text"
            />
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-lg-6">
            <p class="cl-check">
              Tipo de entidad, seleccionar una de las opciones siguientes:
            </p>
            <select
              formControlName="quest4"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="optionD($event)"
              class="form-control"
            >
              <option disabled value="">Selecciona una opción</option>
              <option *ngFor="let dato of dataTwo" [ngValue]="dato">
                {{ dato }}
              </option>
            </select>
          </div>
        </div>

        <div class="row" *ngIf="boxing2">
          <div class="col-lg-4" id="apellidos">
            <label for="apellidos" class="color-s">Nombres</label>
            <div class="form-group">
              <input
                formControlName="quest5"
                (keypress)="lettersOnly($event)"
                class="form-control"
                type="text"
              />
            </div>
          </div>

          <div class="col-lg-4">
            <label for="nombre" class="color-s">Apellidos</label>
            <div class="form-group">
              <input
                formControlName="quest6"
                (keypress)="lettersOnly($event)"
                class="form-control"
                type="text"
              />
            </div>
          </div>
          <div class="col-lg-4">
            <label for="fecha_nacimiento" class="color-s"
              >Fecha Nacimiento</label
            >
            <div class="form-group">
              <input
                formControlName="quest7"
                class="form-control"
                type="date"
              />
            </div>
          </div>

          <div class="col-lg-4">
            <label for="tipo_documento" class="color-s"
              >Tipo de Documento
            </label>
            <select formControlName="quest8" disabled class="form-control">
              <option value="null">Selecciona una opción</option>
              <option value="Dni">Dni</option>
              <option value="Carnet Ext">Carnet Ext.</option>
              <option value="Pasaporte">Pasaporte</option>
              <option value="Otro">Otro</option>
            </select>
          </div>

          <div class="col-lg-4" id="otro_documento">
            <label for="otro_documento" class="color-s"
              >Número del Documento</label
            >
            <div class="form-group">
              <input
                formControlName="quest9"
                maxlength="15"
                (keypress)="numberOnly($event)"
                class="form-control"
                type="text"
              />
            </div>
          </div>

          <div class="col-lg-4">
            <label for="tipo_documento" class="color-s">País</label>
            <select formControlName="quest10" class="form-control">
              <option disabled value="null">Selecciona una opción</option>
              <option value="Perú">Perú</option>
            </select>
          </div>

          <div class="col-lg-4">
            <label for="tipo_documento" class="color-s"
              >País de nacimiento</label
            >
            <select formControlName="quest11" class="form-control">
              <option disabled value="null">Selecciona una opción</option>

              <option value="Perú">Perú</option>
            </select>
          </div>
          <div class="col-lg-4">
            <label for="tipo_documento" class="color-s">Departamento</label>
            <select formControlName="quest12" class="form-control">
              <option disabled value="null">Selecciona una opción</option>
              <option *ngFor="let departamento of departamentosAnexoDjFiscal" [value]="departamento.departamento">
                {{departamento.departamento }}</option>
            </select>

           
          </div>
          <div class="col-lg-4">
            <label for="tipo_documento" class="color-s"
              >¿tiene obligaciones fiscales en otro(s) país(es)?
            </label>
            <select
              formControlName="quest13"
              class="form-control"
            >
              <option disabled value="null">Selecciona una opción</option>
              <option value="Si">Si</option>
              <option value="No">No</option>
            </select>

          </div>
          <div class="col-lg-4">
            <label for="correo" class="color-s">Dirección domicilio</label>
            <div class="form-group">
              <input
                formControlName="quest14"
                class="form-control"
                type="text"
              />
            </div>
          </div>
        </div>

        <p class="cl-check">Mediante el presente documento, declaro que:</p>

        <p
          style="width: 100%; display: flex; align-items: center"
          class="cl-check"
        >
          <input formControlName="quest15" class="mr-3" type="checkbox" />

          1. La información proporcionada es correcta y completa.
        </p>

        <p
          style="width: 100%; display: flex; align-items: center"
          class="cl-check"
        >
          <input formControlName="quest16" class="mr-3" type="checkbox" />

          2. No tengo nacionalidad o residencia fiscal en otros países que no
          haya colocado en esta Declaración.
        </p>

        <p
          style="width: 100%; display: flex; align-items: center"
          class="cl-check"
        >
          <input formControlName="quest17" class="mr-3" type="checkbox" />

          3. Autorizo al INVERSIÓN Y DESARROLLO SAB S.A.C. - IND SAB a
          proporcionar directa o indirectamente, la información contenida en
          esta Declaración y/o proporcionar una copia a SUNAT o cualquier
          entidad autorizada para auditar o realizar un control a INVERSIÓN Y
          DESARROLLO SAB S.A.C. - IND SAB. Asimismo, autorizo se entregue copia
          de la presente declaración a las Instituciones de Compensación y
          Liquidación de Valores (ICLV), conforme a la normativa vigente.
        </p>

        <p
          style="width: 100%; display: flex; align-items: center"
          class="cl-check"
        >
          <input formControlName="quest18" class="mr-3" type="checkbox" />

          4. Me comprometo a comunicar al INVERSIÓN Y DESARROLLO SAB S.A.C. -
          IND SAB sobre cualquier cambio de circunstancias para la presente
          Declaración y actualizarla en un plazo de 30 días a partir de la fecha
          de cambio.
        </p>
        <div class="col-md-12 empuje" align="center">
          <div class="form-group">
            <button
              [disabled]="!form3.valid"
              (click)="saveOneAnexo()"
              style="width: 50%"
              class="btn btn-rounded btn-blue btn-block"
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #modalDjPep let-modal>
  <div class="modal-header">
    <button
      type="button"
      class="close"
      aria-label="Close button"
      aria-describedby="modal-title"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h4 class="modal-title cl-titl" id="modal-title">Anexo DJ PEP</h4>
    <div>
      <p class="cl-check">
        Relación de vinculados hasta el segundo grado de consanguinidad y
        segundo de afinidad, cónyuge y/o conviviente:
      </p>
      <form [formGroup]="form2">
        <div class="row">
          <div class="col-lg-6">
            <label for="tipo_persona">Nombres</label>
            <input
              formControlName="quest1"
              (keypress)="lettersOnly($event)"
              class="form-control"
              type="text"
            />
          </div>

          <div class="col-lg-6">
            <label for="apoderado">Apellidos</label>
            <input
              formControlName="quest2"
              (keypress)="lettersOnly($event)"
              class="form-control"
              type="text"
            />
          </div>

          <div class="col-lg-4 mt-3">
            <label for="tipo_documento">Tipo de documento </label>
            <select
              formControlName="quest3"
             
              class="form-control"
            >
              <option disabled value="">Selecciona una opción</option>
              <option value="Dni">Dni</option>
              <option value="Carnet Ext">Carnet Ext.</option>
              <option value="Pasaporte">Pasaporte</option>
              <option value="Carnet Iden">Carnet Iden.</option>
            </select>
          </div>

          <div class="col-lg-3 mt-4" id="otro_documento">
            <label for="otro_documento">Número del documento</label>
            <div class="form-group">
              <input
                formControlName="quest4"
                maxlength="9"
                (keypress)="numberOnly($event)"
                class="form-control"
                type="text"
              />
            </div>
          </div>

          <div class="col-lg-4 mt-3">
            <label for="tipo_documento">Parentesco</label>
            <select
              formControlName="quest5"
              class="form-control"
            >
              <option disabled value="">Selecciona una opción</option>
              <option value="Padre">Padre</option>
            </select>
          </div>
        </div>
        <p class="cl-check">
          Relación de personas jurídicas o entes jurídicos donde mantenga una
          participación igual o superior al 25% de su capital social, aporte o
          participación
        </p>
        <div class="row">
          <div class="col-lg-6">
            <label for="tipo_persona">Razón social</label>
            <input
              formControlName="quest6"
              (keypress)="lettersOnly($event)"
              class="form-control"
              type="text"
            />
          </div>

          <div class="col-lg-6">
            <label for="tipo_documento">Tipo de documento </label>
            <select
              formControlName="quest7"
              class="form-control"
            >
              <option disabled value="">Selecciona una opción</option>
              <option value="Dni">Dni</option>
              <option value="Carnet Ext">Carnet Ext.</option>
              <option value="Pasaporte">Pasaporte</option>
              <option value="Carnet Iden">Carnet Iden.</option>
            </select>
          </div>

          <div class="col-lg-4 mt-3" id="otro_documento">
            <label for="otro_documento">Número del documento</label>
            <div class="form-group">
              <input
                formControlName="quest8"
                maxlength="9"
                (keypress)="numberOnly($event)"
                class="form-control"
                type="text"
              />
            </div>
          </div>

          <div class="col-lg-4 mt-3">
            <label> País</label>
            <select
              formControlName="quest9"
              class="form-control"
            >
              <option disabled value="">Selecciona una opción</option>
              <option value="Peru">Peru</option>
            </select>
          </div>

          <div class="col-lg-4 mt-3">
            <label for="tipo_persona">Participación</label>
            <input
              formControlName="quest10"
              (keypress)="numberOnly($event)"
              class="form-control"
              min="1"
              max="100"
              type="number"
            />
          </div>
        </div>
      </form>
    </div>
    <div class="col-md-12 empuje" align="center">
      <div class="form-group">
        <button
          [disabled]="!form2.valid"
          (click)="saveTwoAnexo()"
          style="width: 50%"
          class="btn btn-rounded btn-blue btn-block"
        >
          Aceptar
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modalDjInversionista let-modal>
  <div class="modal-header">
    <button
      type="button"
      class="close"
      aria-label="Close button"
      aria-describedby="modal-title"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h4 class="modal-title cl-titl" id="modal-title">
      Anexo DJ inversionista institucional
    </h4>

    <form [formGroup]="form">
      <div>
        <p
          style="width: 100%; display: flex; align-items: center"
          class="cl-check"
        >
          <input formControlName="questone" class="mr-3" type="checkbox" />

          "Por la presente declaro que me encuentro dentro de los alcances de la
          Resolución de Superintendencia Nro. 00021-2013-SMV/01 y su anexo 01
          referente a las personas calificadas como Inversionistas
          Institucionales."
        </p>

        <p
          style="width: 100%; display: flex; align-items: center"
          class="cl-check"
        >
          <input formControlName="questtwo" class="mr-3" type="checkbox" />

          "Por este motivo declaro mi condición como inversionista institucional
          a IND, para los fines correspondientes."
        </p>
      </div>
      <div class="col-md-12 mt-4 empuje" align="center">
        <div class="form-group">
          <button
            [disabled]="!form.valid"
            (click)="saveTreeAnexo()"
            style="width: 50%"
            class="btn btn-rounded btn-blue btn-block"
          >
            Aceptar
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
